import { format } from "date-fns"
import { Fragment, useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Calendar } from "../../../../ui/molecules/calendar"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch"
import RadioButtonGroup from "../../../../ui/molecules/RadioButtonGroup"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { CustomOptions, revisioneOptions, typologyOptions } from "../../../../utils"
import { GetByIdPersonalManagement } from "../../slice"
import { ContractCreation, ContractValidation, resetContractCreationRequest, resetContractCreationStatus, resetContractErrors, resetContractValidationStatus, setContractType, setEndingDate, setKmIndennity, setNumContract, setProtocolIdDeparture, setRevisionType, setStartingDate, setStipulate } from "../slice"

interface Props {
    close: () => void;
}

export function ContrattiPopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const contractsState = useAppSelector(state => state.PMContracts)
    const PMState = useAppSelector(state => state.personalManagement)
    const [selectedOption, setSelectedOption] = useState<CustomOptions | null>(CustomOptions.NO)

    const handleOptionChange = (value: CustomOptions) => {
        setSelectedOption(value)
        dispatch(setKmIndennity(value === 'YES'))
    }

    useEffect(() => {
        if (contractsState.contractValidationStatus === 'successfully') {
            dispatch(resetContractValidationStatus())
            dispatch(resetContractErrors())
            dispatch(ContractCreation(contractsState.contractCreationRequest))
        }
    }, [contractsState.contractValidationStatus])

    useEffect(() => {
        if (contractsState.contractCreationStatus === 'successfully') {
            dispatch(resetContractCreationRequest())
            dispatch(resetContractCreationStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [contractsState.contractCreationStatus])

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Tipologia"
                        placeholder="Seleziona tipologia..."
                        options={typologyOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setContractType(newValue))
                        }}
                        defaultValue={contractsState.contractCreationRequest.contractType}
                        value={contractsState.contractCreationRequest.contractType}
                        error={contractsState.contractErrors.contractType}
                        errorLabel="Tipologia mancante"
                        noOptionsMessage={""}
                    />
                    <MadfarmInput
                        label="N. contratto"
                        placeholder="Digita numero contratto..."
                        value={contractsState.contractCreationRequest.numContract}
                        defaultValue={contractsState.contractCreationRequest.numContract}
                        onChangeText={(text) => dispatch(setNumContract(text))}
                        error={contractsState.contractErrors.numContract}
                        supportingText={contractsState.contractErrors.numContract ? 'Numero del contratto mancante' : undefined}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Revisione"
                        placeholder="Seleziona..."
                        options={revisioneOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setRevisionType(newValue))
                        }}
                        defaultValue={contractsState.contractCreationRequest.revisionType}
                        value={contractsState.contractCreationRequest.revisionType}
                        error={contractsState.contractErrors.revisionType}
                        errorLabel="Tipologia revisione mancante"
                        noOptionsMessage={""}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Calendar
                        label="Data stipula"
                        selected={contractsState.contractCreationRequest.stipulate}
                        onChange={(date) => dispatch(setStipulate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                    <Calendar
                        label="Data inizio"
                        selected={contractsState.contractCreationRequest.starting}
                        onChange={(date) => dispatch(setStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                    <Calendar
                        label="Data fine"
                        selected={contractsState.contractCreationRequest.ending}
                        onChange={(date) => dispatch(setEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Indennità chilometrica nel raggio di 50 km
                    </span>
                    <RadioButtonGroup
                        name="km_indennity"
                        options={Object.values(CustomOptions)}
                        selectedValue={selectedOption}
                        onChange={handleOptionChange}
                        optionLabels={{
                            [CustomOptions.YES]: 'SI',
                            [CustomOptions.NO]: 'NO',
                        }}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Protocollo Partenza</p>
                </div>
                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="departure"
                        onSelect={(value) => dispatch(setProtocolIdDeparture(value))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetContractErrors())
                            dispatch(resetContractCreationRequest())
                            props.close()
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Aggiungi"
                        color="orange"
                        onClick={() => {
                            dispatch(ContractValidation(contractsState.contractCreationRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}